import { render, staticRenderFns } from "./BcProgressLoader.vue?vue&type=template&id=6b585be9&scoped=true"
import script from "./BcProgressLoader.vue?vue&type=script&lang=js"
export * from "./BcProgressLoader.vue?vue&type=script&lang=js"
import style0 from "./BcProgressLoader.vue?vue&type=style&index=0&id=6b585be9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b585be9",
  null
  
)

export default component.exports